import { render, staticRenderFns } from "./ComprobanteTable2.vue?vue&type=template&id=8889667c"
import script from "./ComprobanteTable2.vue?vue&type=script&lang=js"
export * from "./ComprobanteTable2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports